const SITE = "Rex & Sons RVs";
const BASE = "https://www.rexandsonsrvs.com";

/**
 * Standard per-route head() payload: unique title, description, canonical,
 * og:* and twitter:* tags. Keeps every public route from falling back to the
 * root layout's shared metadata (duplicate-title/social SEO findings).
 */
export function pageHead(opts: {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: string;
}) {
  const title = opts.title.includes(SITE) ? opts.title : `${opts.title} | ${SITE}`;
  const url = `${BASE}${opts.path}`;
  const meta: Record<string, string>[] = [
    { title },
    { name: "description", content: opts.description },
    { property: "og:type", content: opts.type ?? "website" },
    { property: "og:title", content: title },
    { property: "og:description", content: opts.description },
    { property: "og:url", content: url },
    { name: "twitter:card", content: opts.image ? "summary_large_image" : "summary" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: opts.description },
  ];
  if (opts.image) {
    meta.push({ property: "og:image", content: opts.image });
    meta.push({ name: "twitter:image", content: opts.image });
  }
  return {
    meta,
    links: [{ rel: "canonical", href: url }],
  };
}
